export { default as InventarioOtrosAcopios } from "./InventarioOtrosAcopios";

export { default as SobranteAlmacenConsulta } from "./SobranteAlmacenConsulta";
